/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import PageLoader from 'components/pageLoader'
import type React from 'react'
import { lazy, Suspense, useMemo, type JSX } from 'react'

type ImportFunction = () => Promise<{
	default: (properties: any) => JSX.Element | null
}>

const DEFAULT_FALLBACK = <PageLoader />

function lazyLoad(
	importComponent: ImportFunction,
	fallback: React.ReactNode = DEFAULT_FALLBACK
) {
	const LazyComponent = lazy(importComponent)

	return function WithLazyLoadingHOC(props: any) {
		const memoizedFallback = useMemo(async () => fallback, [])

		return (
			<Suspense fallback={memoizedFallback}>
				<LazyComponent {...props} />
			</Suspense>
		)
	}
}

export default lazyLoad
